export default {
  username: 'Gebruikersnaam',
  password: 'Wachtwoord',
  submit: 'Log in',
  continue: 'Ga door zonder in te loggen',
  error:
    'Er is een fout of de gebruikersnaam of het wachtwoord is onjuist.<br/> De pagina wordt binnen enkele seconden opnieuw geladen of u kunt handmatig doorgaan.',
}
